import React from 'react'
import { BrowserRouter, Routes, Route,Link } from "react-router-dom";
import './style.css'


export default function Header() {
  return (
    <div>

<div style={{ marginTop: '20px' }} className="topCenter">
      <ul className="topList">
        <li className="topListItem">
          <Link className="link" to="/">
         HOME
          </Link>
        </li>
        <Link className="topListItem link" to="about"> ABOUT ME</Link>
        <li className="topListItem">
          <Link className="link" to="projects">
         PROJECTS
          </Link>
        </li>
        <Link className="topListItem link" to="qr">SHARE</Link>
      </ul>
    </div>
  </div>
    

  )
}
